"use client"
import React, { forwardRef, useState } from 'react';
import { Delete } from '@mui/icons-material';
import _ from 'lodash';
import ButtonComponent from '@/Inputs/ButtonComponent';
import { FloatValues, cn, getCurrencySign, storeAssigned, getCurrencyCode } from '@/services/Methods/normalMethods';
import { notFoundImage } from '@/assets/images';
import Image from 'next/image';
import moment from 'moment';
import DatePicker from 'react-datepicker';

const OrderSummery = ({
    cartData, usePoint, _increseCheckoutQuantity, _deleteProductFunction, calculate, section, setSmartSaveSchedule, subTotal, addToCartProducts
}) => {
    const CURRENT_STORE = _.upperCase(storeAssigned()) || 'US';

    const [startDate, setStartDate] = useState(new Date());
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className="example-custom-input text-left w-full p-[10px] tracking-[4px] border border-[#dddd]" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    function isWeekday(date) {
        const day = new Date(date).getDate();
        return !_.includes([29, 30, 31], day);
    }

    const isJapan = _.upperCase(storeAssigned()) === 'JP';

    const PriceArray = usePoint?.paymentObject?.maxAmount
        ? [
            { Subtotal: isJapan ? parseFloat(calculate?.subTotal || subTotal?.productSubTotal) : parseFloat(calculate?.subTotal || subTotal?.productSubTotal).toFixed(2) },
            { Shipping: calculate?.shippingTotal || (isJapan ? '0' : '0.00') },
            { Taxes: isJapan ? parseFloat(calculate?.taxTotal || 0) : parseFloat(calculate?.taxTotal || 0).toFixed(2) },
            { Points: isJapan ? parseFloat(usePoint?.paymentObject?.maxAmount || 0) : parseFloat(usePoint?.paymentObject?.maxAmount || 0).toFixed(2) },
            {
                Total: isJapan
                    ? parseFloat(parseFloat(calculate?.orderTotal || subTotal?.productSubTotal) - parseFloat(usePoint?.paymentObject?.maxAmount || 0))
                    : parseFloat(parseFloat(calculate?.orderTotal || subTotal?.productSubTotal) - parseFloat(usePoint?.paymentObject?.maxAmount || 0)).toFixed(2)
            }
        ]
        : [
            { Subtotal: isJapan ? parseFloat(calculate?.subTotal || subTotal?.productSubTotal) : parseFloat(calculate?.subTotal || subTotal?.productSubTotal).toFixed(2) },
            { Shipping: calculate?.shippingTotal || (isJapan ? '0' : '0.00') },
            { Taxes: isJapan ? parseFloat(calculate?.taxTotal || 0) : parseFloat(calculate?.taxTotal || 0).toFixed(2) },
            { Total: isJapan ? parseFloat(calculate?.orderTotal || subTotal?.productSubTotal) : parseFloat(calculate?.orderTotal || subTotal?.productSubTotal).toFixed(2) }
        ];

    return (
        <div className='order-summary mb-6' style={{ padding: "0" }}>
            <h2 className='lg:text-xl text-[18px] lg:text-left text-center mb-4'>{section} Order Summary</h2>
            {/* <Divider sx={{ marginBottom: '15px' }} /> */}
            <div className='order-data'>
                <table className='w-full'>
                    <tbody className='flex flex-wrap'>
                        {_.map(cartData, (items) => {
                            const _ProductsImg = _.find(addToCartProducts?.normalProducts, { id: items?.id })?.image;
                            return (
                                <React.Fragment key={items?.id}>
                                    <tr className='all-products flex items-center border-t-[1px] border-clr py-[26px] w-full' >
                                        <td className='mr-[8px] xl:w-[69px] w-[50px]'>
                                            <figure className='xl:h-[69px] xl:w-[69px] h-[50px] w-[50px] m-0 rounded-[6px] border-[1px] border-clr bg-white p-[5px]'>
                                                {_ProductsImg
                                                    ?
                                                    <img src={_ProductsImg} className='h-full w-full object-contain' />
                                                    :
                                                    <Image src={notFoundImage} alt="Image 10" className="w-full h-full object-contain" />
                                                }
                                            </figure>
                                        </td>
                                        <td className='products-details-order px-[8px] w-[calc(100%-69px-71px)]'>
                                            <span className='block text-[15px] leading-[1.2] font-normal'> {items?.productName} </span>
                                            {_increseCheckoutQuantity
                                                ?
                                                <ButtonComponent classes="bg-inherit  w-full max-w-[110px]">
                                                    <div className="flex items-center text-button-color justify-around lg:text-sm xl:text-lg !leading-3">
                                                        <span
                                                            className="hover:text-primary cursor-pointer py-2 px-2 hover:!text-[#f586a3]"
                                                            onClick={() => console.log(id, "sub")}
                                                        >
                                                            -
                                                        </span>
                                                        <span>{items?.quantity}</span>
                                                        <span
                                                            className="hover:text-primary cursor-pointer py-2 px-2 hover:!text-[#f586a3]"
                                                            onClick={() => console.log(id, "add")}
                                                        >
                                                            +
                                                        </span>
                                                    </div>
                                                </ButtonComponent>
                                                :
                                                <span className="item-qty text-[14px] leading-[1.2] font-normal   ">QTY:{items?.quantity}</span>
                                            }
                                            <span className='iteam-para'>{items?.para}</span>
                                        </td>
                                        <td className='item-icon  pl-[8px] w-[71px]'>
                                            {(!(['member']?.includes(items?.autoship)) && _deleteProductFunction) &&
                                                <span className='delete-icon' onClick={() => {
                                                    _deleteProductFunction(+items?.id, items?.autoship);
                                                }}> <Delete /></span>
                                            }
                                            <span className='price-note text-right block text-[15px] leading-[1.2] font-normal'>{getCurrencySign(CURRENT_STORE)}{items?.price ? FloatValues(items?.price) : ""}</span>
                                        </td>
                                    </tr>
                                    {_.map(items?.subProducts, (row) => (
                                        <tr className='all-products sub_products_values' key={row?.id + 1}>
                                            <td></td>
                                            <td className='products-details-order'>
                                                <h4> {row?.productName} </h4>
                                                {!(['member', 'now']?.includes(row?.autoship)) &&
                                                    <span className='item-qty'>QTY:{row?.quantity}</span>
                                                }
                                                <span className='iteam-para'>{row?.para}</span>
                                            </td>
                                        </tr>
                                    ))
                                    }
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </table>
                {/* <Divider sx={{ margin: '10px 0' }} /> */}
                <div className='price-calulate pt-[18px] border-t-[1px] border-clr '>
                    {_.map(PriceArray, (row) => _.map(_.entries(row), ([key, value]) => (
                        <div className='subtotal-item mb-1' key={key}>
                            <p className={cn(`flex flex-wrap justify-between text-[15px] leading-[1.2] font-normal`, 'price', {
                                'text-[16px] font-semibold': key === "Total"
                            })}>
                                {key}: <span className={cn('block ml-auto text-[15px]', 'total', { 'text-[16px] font-semibold': key === "Total" })}><span className='text-gray-400 m-2'>{key === "Total" && getCurrencyCode(CURRENT_STORE)}</span>{getCurrencySign(CURRENT_STORE)}{value}</span>
                            </p>
                        </div>
                    )))}
                </div>
                {/* {moment().month(1).date(28).format("YYYY-MM-DD")} */}
                {(section === "Subscription") &&
                    <div className='datePicker pt-10'>
                        <h2 className='lg:text-xl text-[18px] lg:text-left text-center mb-4'>Subscription Scheduling</h2>
                        <div>
                            <p className='mb-2'>Select your start date</p>
                            <DatePicker
                                className='w-full'
                                selected={startDate}
                                minDate={new Date()}
                                onChange={(date) => {
                                    setStartDate(date);
                                    setSmartSaveSchedule(moment(date).utc().format());
                                }}
                                customInput={<ExampleCustomInput />}
                                filterDate={isWeekday}
                            // placeholderText="Select a date other than today or yesterday"
                            />
                        </div>

                    </div>
                }
            </div>
        </div >
    )
};
export default OrderSummery